import React from 'react'
import PropTypes from 'prop-types'

import { routes } from 'routes'
import { reverse } from 'named-urls'
import useForm from 'react-hook-form'
import { Link as RouterLink, useHistory } from 'react-router-dom'
import { RHFInput } from 'react-hook-form-input'

import {
  Box,
  Paper,
  TextField,
  Divider,
  Button,
  makeStyles,
  Typography,
  Link,
} from '@material-ui/core'

import { PermIdentityOutlined, ControlPointOutlined } from '@material-ui/icons'

import { RadioCard, RadioCardGroup } from 'components/Form'
import * as service from 'service'
import schemas from '../../schemas'
import useFetch from 'hooks/useFetch'
import helpers from 'helpers'
import styles from './styles'

const useStyles = makeStyles(styles)

const RadioCardProfile = ({ profile, onClickShowPermissions }) => {
  const classes = useStyles()

  return (
    <RadioCard value={profile.id}>
      <div className={classes.radioCardContainer}>
        <div className={classes.profileTitle}>
          <PermIdentityOutlined
            color="primary"
            className={classes.profileIcon}
          />
          <Typography color="primary" className={classes.profileName}>
            {profile.name}
          </Typography>
        </div>
        <Link onClick={event => onClickShowPermissions(event, profile)}>
          <Typography color="secondary" className={classes.profilePermissions}>
            Ver permissões
          </Typography>
        </Link>
      </div>
    </RadioCard>
  )
}

const CardAddProfile = ({ onClick }) => {
  const classes = useStyles()

  return (
    <Link onClick={onClick} className={classes.addProfileLink}>
      <Paper variant="outlined" elevation={0} className={classes.addProfile}>
        <ControlPointOutlined color="primary" className={classes.profileIcon} />

        <Typography color="primary" className={classes.addProfileName}>
          Criar perfil personalizado
        </Typography>
      </Paper>
    </Link>
  )
}

const UsersForm = ({ userId, data, onSubmit }) => {
  const classes = useStyles()
  const history = useHistory()

  const { handleSubmit, register, errors, setValue, getValues } = useForm({
    defaultValues: data || {},
    validationSchema: schemas.data,
  })

  const { response: responseProfiles } = useFetch(
    service.recurrence.profiles.get,
    { perPage: 1000 },
  )

  const handleClickShowPermission = (event, profile) => {
    event.preventDefault()
    event.stopPropagation()

    history.push({
      pathname: reverse(routes.settings.profiles.edit, {
        profileId: profile.id,
      }),
      state: {
        fromUsers: true,
        disableForm: true,
        user: { id: data && data.id, ...getValues() },
      },
    })
  }

  const handleClickAddProfile = () => {
    history.push({
      pathname: reverse(routes.settings.profiles.new),
      state: {
        fromUsers: true,
        user: { id: data && data.id, ...getValues() },
      },
    })
  }

  return (
    <Paper>
      <form onSubmit={handleSubmit(onSubmit)} id="users-form">
        <Box p={2}>
          <RHFInput
            as={
              <TextField
                label="Nome"
                margin="dense"
                error={!!errors.name}
                helperText={errors && errors.name && errors.name.message}
                fullWidth
              />
            }
            name="name"
            register={register}
            setValue={setValue}
          />
          <RHFInput
            as={
              <TextField
                label="Email"
                margin="dense"
                error={!!errors.email}
                helperText={errors && errors.email && errors.email.message}
                fullWidth
              />
            }
            name="email"
            register={register}
            setValue={setValue}
          />
          <RHFInput
            as={
              <TextField
                label="Senha"
                type="password"
                margin="dense"
                error={!!errors.password}
                helperText={
                  errors && errors.password && errors.password.message
                }
                fullWidth
              />
            }
            name="password"
            register={register}
            setValue={setValue}
          />

          <div>
            <Typography variant="h5" className={classes.radioCardGroupTitle}>
              Selecione o perfil do usuário
            </Typography>

            <RHFInput
              as={
                <RadioCardGroup name="profileId">
                  {responseProfiles &&
                    helpers.profiles
                      .hideMainProfile(responseProfiles.data.profiles)
                      .map(profile => (
                        <RadioCardProfile
                          profile={profile}
                          onClickShowPermissions={handleClickShowPermission}
                          key={profile.id}
                        />
                      ))}

                  <CardAddProfile onClick={handleClickAddProfile} />
                </RadioCardGroup>
              }
              name="profileId"
              register={register}
              setValue={setValue}
            />
          </div>
        </Box>

        <Divider />

        <Box p={2}>
          <Button
            className={classes.btnSave}
            color="primary"
            variant="contained"
            type="submit"
            form="users-form"
          >
            Salvar
          </Button>
          <Button
            color="primary"
            variant="outlined"
            component={RouterLink}
            to={{ pathname: reverse(routes.settings.all), state: { value: 5 } }}
          >
            Cancelar
          </Button>
        </Box>
      </form>
    </Paper>
  )
}

UsersForm.propTypes = {
  data: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
}

export default UsersForm
